// 마을 창(RpgUi)이 열리거나 닫힐 때 window로 보내는 이벤트 이름. 커뮤니티 단추 접기가 듣는다(폴링 대신)
export const RPG_WINDOW_EVENT = 'dh-rpg-window';

/**
 * 창 덮개의 data-open을 바꾸고 커뮤니티 단추 접기에 알린다(캐릭터 선택·생성 화면처럼 열림 상태를 data-open으로 두는 화면용).
 * 값이 그대로면 아무것도 하지 않는다. target은 시험에서 가짜로 바꾼다
 */
export function setWindowOpenFlag(root: { dataset: { open?: string } }, open: boolean, target: Pick<EventTarget, 'dispatchEvent'> | undefined = typeof window !== 'undefined' ? window : undefined): void {
  const v = open ? '1' : '0';
  if (root.dataset.open === v) return;
  root.dataset.open = v;
  target?.dispatchEvent(new Event(RPG_WINDOW_EVENT));
}
